/* unplugin-vue-components disabled */import { render } from "./BluetoothRingController.vue?vue&type=template&id=7a884942"
import script from "./BluetoothRingController.vue?vue&type=script&lang=js"
export * from "./BluetoothRingController.vue?vue&type=script&lang=js"

import "./BluetoothRingController.vue?vue&type=style&index=0&id=7a884942&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__